
<mat-accordion class="call-center-options-container" multi>
  <mat-expansion-panel *ngFor="let branch of listData" [expanded]="(products | filterObj:'ramosId':branch.Ramo_Id)?.length > 0">
    <mat-expansion-panel-header collapsedHeight="4.375rem" expandedHeight="5rem">
      <mat-panel-title class="call-center-branch">
        <img alt="" class="call-center-icon" [ngSrc]="'../assets/img/portal/home-'+(branch.Icon || 'hospitalization.svg')" width="38" height="38" />
        {{branch.Ramo_Name}}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ul class ="options-container container-products">
      <li class="option-product" *ngFor="let prod of products | filterObj:'ramosId':branch.Ramo_Id">
        <mat-card class="card-product">
          <div class="card-img-mask mat-card-image">
            <img [ngSrc]="'../assets/img/'+prod.icon" width="278" height="154" [alt]="prod.name">
          </div>
          <mat-card-content>
            <h5 class="text-center font-weight-normal">{{prod.name}}</h5>
            <div [innerHTML]="prod?.descriptionF2F"></div>
          </mat-card-content>
          <mat-card-footer class="bg-gray cta-container">
            <div class="no-bstrp" [innerHTML]="prod?.primeText"></div>
            <button mat-flat-button color="accent" class="button-conoce" (click)="goToPlans($event, prod)">
              <a>{{ prod?.text_Route || "Conoce más detalles" }}</a>
              <mat-icon>arrow_forward</mat-icon>
            </button>
            <button *ngIf="campaignService.CTAEmailShow" mat-stroked-button color="accent" class="mt-2 button-email" [disabled]="prod?.modal_Age && campaignData?.range_age_type == '66 - *'" (click)="openModalMail($event, prod)">
              Enviar oferta por correo
            </button>
          </mat-card-footer>
        </mat-card>
      </li>
    </ul>
    <!--ul class="pl-0 call-center-product-list">
      <li class="call-center-product-item" *ngFor="let prod of products | filterObj:'ramosId':branch.Ramo_Id" (click)="goToPlans($event, prod)">
        <mat-card class="card-product">
          <figure class="card-img-mask mat-card-image">
            <img [src]="'../assets/img/'+prod.icon" />
            <figcaption class="card-img-text"><p>{{prod.name}}</p></figcaption>
          </figure>
        </mat-card>
      </li>
    </ul-->
  </mat-expansion-panel>
